(function() {
    'use strict';

    a3_pilot_reports.controller('ProposalInfoModalCtr', ProposalInfoModalCtr)
    /**
     * @memberof PilotReports
     * @ngdoc controller
     * @name ProposalInfoModalCtr
     * @description 
     * Shows duty crew and route info
     * @ngInject
     */

    function ProposalInfoModalCtr($scope, $uibModalInstance, ProposedDuties, RequestedDuties, Id, Status, State){
        $scope.RequestedDuties = RequestedDuties;
        $scope.ProposedDuties = ProposedDuties;

        $scope.cancel = cancel; 
        $scope.next = next;
        $scope.previous = previous;

        var allDuties = [];

        //"You give" items are put first in list
        if(Status == "Shared" || State == "Out"){
            allDuties = ProposedDuties.concat(RequestedDuties);
        }
        else{   //State == "In"
        allDuties = RequestedDuties.concat(ProposedDuties);
        }
        
        for(var i = 0; i < allDuties.length; i++){
            if(allDuties[i].Id == Id){
                 $scope.currentPage = i+1;
                 break;
            }
         }

        $scope.allDuties = allDuties;
 
        /**
         * Moves to next duty
         * @memberof ProposalInfoModalCtr
         */
        function next(){
            if($scope.currentPage != allDuties.length)
                $scope.currentPage++;
        }

        /**
         * Moves to previous duty
         * @memberof ProposalInfoModalCtr
         */
        function previous(){
            if($scope.currentPage != 1)
                $scope.currentPage--;
        }

        /**
         * Closes modal
         * @memberof ProposalInfoModalCtr
         */
        function cancel() {
        $uibModalInstance.close('cancel');
        }
    }
})();
